import React from 'react';
import { useSelector } from 'react-redux';
import { getRecapState } from './store/selectors/getRecap';
import Recap from './Recap';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import recapReducer from './store/reducers/recap';

import contentGraphDatasource from '@gameday/core/datasources/contentGraph';
import contentDatasource from '@gameday/core/datasources/content';

import recapDataRequestAction from './store/actions/recapDataRequestAction';

initContainerData.register({
    datasources: {
        content: contentDatasource,
        contentGraph: contentGraphDatasource
    },
    reducers: {
        recap: recapReducer
    }
});

const fetchData = () => {
    return recapDataRequestAction();
};

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const RecapDataContainer = (props) => {
    const recapState = useSelector(getRecapState);
    return (
        <Recap { ...recapState } {...props} />
    );
};

export default RecapDataContainer;
export { fetchData, routes };
